import React, { useMemo, useState } from 'react';
import { Card } from 'react-bootstrap';

import { GetStepDefinitionDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { Grid } from '../../../common/components/Grid/Grid';
import { GridColumn } from '../../../common/components/Grid/GridDataTypes';
import {
  TimelineHintDeadlineObj,
  TimelineStageObj,
  TimelineStepEnumObj,
} from '../../../common/pokCore/validation/enums';
import { GridRecord } from '../../../common/components/Grid/GridDataTypes';

export const StepsView: React.FC = () => {
  const pok = usePokCore();
  const notifications = useNotifications();
  const { t, tk } = useTranslation('projectLng');
  const [steps, setSteps] = useState<GetStepDefinitionDto[]>([]);

  useMemo(() => {
    pok.stepDefinitions
      .getAllActive()
      .then((data: GetStepDefinitionDto[]) => {
        setSteps(data);
      })
      .catch(async errorResponse => {
        notifications.caughtError(errorResponse);
      });
  }, [notifications, pok.stepDefinitions]);

  const columns: GridColumn[] = [
    {
      header: t(tk.common.type),
      property: 'stepType',
    },
    {
      header: t(tk.timeLine.stage),
      property: 'stageName',
    },
    {
      header: t(tk.timeLine.order),
      property: 'order',
    },
    {
      header: t(tk.timeLine.deadline),
      property: 'deadline',
    },
    {
      header: t(tk.timeLine.automatic),
      property: 'automatic',
    },
  ];

  const gridData: GridRecord[] = steps.map(step => ({
    key: step.id,
    values: {
      stepType: t(TimelineStepEnumObj[step.stepType]),
      stageName: step.stageDefinition
        ? t(TimelineStageObj[step.stageDefinition.stageType])
        : '-',
      order: step.order.toString(),
      deadline: t(TimelineHintDeadlineObj[step.deadline]) || '-',
      automatic: step.automatic ? t(tk.common.yes) : t(tk.common.no),
    },
    orderByNumberValues: {
      order: step.order,
    },
  }));

  return (
    <Card className="main-card">
      <Card.Body className="m-3">
        <Card.Title className="pb-3">{t(tk.timeLine.timeLineSteps)}</Card.Title>
        <Grid
          data={gridData}
          columns={columns}
          showFilter={true}
          pageSize={20}
          initialOrderColumn="stageName"
          initialOrderDirection="ASC"
          emptyGridMessage={t(tk.common.noData)}
          withFilterInColumns={true}
        />
      </Card.Body>
    </Card>
  );
};
